import React from 'react';
import ManagementTotals from './Management';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';

const ManagementTotalsWrapper = () => {
    return (
        <ServicesChartsDataProvider
            module={{
                sectionTitle: 'do Financiamento da Gestão'
            }}
        >
            <ManagementTotals />
        </ServicesChartsDataProvider>
    );
};

export default ManagementTotalsWrapper;
